import { render, staticRenderFns } from "./AddonForm.vue?vue&type=template&id=01199162&scoped=true&"
import script from "./AddonForm.vue?vue&type=script&lang=js&"
export * from "./AddonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01199162",
  null
  
)

export default component.exports